<h1 i18n="accounts|Page title">Accounts</h1>

<app-paginated-table
  #accountsTable
  [columns]="columns"
  [filters]="filters"
  [query]="accountsGQL"
  [dataMapper]="dataMapper"
  [rowMenuItems]="rowMenuItems"
  (selectionChange)="onSelectionChange($event)"
  (selectAllChange)="onSelectAllChange($event)"
  (filterQueryParameterChange)="onFilterQueryParameterChange($event)">
</app-paginated-table>

<p-toolbar>
  <ng-template #start>
    <p-button icon="pi pi-download" label="Export" (click)="onExportClick()" i18n="accounts|Export button"></p-button>
    <p-button icon="pi pi-plus" label="New account" (click)="onCreateNewAccount()" i18n="accounts|Create new account button"></p-button>
  </ng-template>
</p-toolbar>

<p-dialog header="Edit Account {{ selectedAccount?.clientNumber || '' }}" i18n-header="accounts|Edit account dialog title" [modal]="true" [(visible)]="accountFormVisible" [style]="{ width: '50rem' }">
  <app-edit-account
  [account]="selectedAccount"
  [success]="onAccountEditSuccess">
  </app-edit-account>
</p-dialog>

<p-dialog
  header="New Account"
  i18n-header="accounts|New account dialog title"
  [modal]="true"
  [(visible)]="newAccountFormVisible"
  [closable]="!creatingAccount"
  [closeOnEscape]="!creatingAccount"
  [style]="{ width: '50rem' }">
  <app-create-account
  [success]="onCreateAccountSuccess"
  (submittingChange)="creatingAccount = $event">
  </app-create-account>
</p-dialog>